import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-anchor', 'top', 'Ritiniet līdz lapas augšdaļai');
Labels.set('ui-anchor', 'bottom', 'Ritiniet līdz lapas apakšai');
Labels.set('ui-anchor', 'left', 'Ritiniet pa kreisi');
Labels.set('ui-anchor', 'right', 'Ritiniet pa labi');
